import { useEffect, useRef } from 'react';
import { TbSearch } from 'react-icons/tb';
import type { MobileNavigationProps } from './types';

type SearchProps = NonNullable<MobileNavigationProps['search']> & {
  id: string;
  open: boolean;
  onDismiss: () => void;
};

export default function Search({
  id,
  action,
  query,
  open,
  onDismiss,
}: SearchProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const input = inputRef.current;
    if (!open || !input) return;
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  }, [open]);

  return (
    <>
      {open && (
        <div
          className="bio-mobile-search-backdrop"
          aria-hidden="true"
          onClick={onDismiss}
        />
      )}
      <div id={id} className="bio-mobile-search" hidden={!open}>
        <form action={action} method="get" role="search">
          <input
            ref={inputRef}
            type="search"
            name="q[full_text_or_prefix_barcode]"
            defaultValue={query}
            placeholder="Search products..."
            aria-label="Search products"
            className="bio-mobile-search__input"
          />
          <button
            type="submit"
            aria-label="Submit search"
            className="bio-mobile-search__submit"
          >
            <TbSearch size={22} />
          </button>
        </form>
      </div>
    </>
  );
}
